import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import DemeritEducationFailCustomerInfoBottomSheet from '@di-shared/features/public-service/demerit-education/DemeritEducationFailCustomerInfoBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function DemeritEducationFailCustomerInfoBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <DemeritEducationFailCustomerInfoBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
